/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import { forwardRef } from 'react'
import Icon from '../icon/icon'

const ListIconSvg = forwardRef((props, svgRef) => (
	<svg
		width={props.width || (props.height && Math.floor(+props.height * 1)) || 24}
		height={props.height || (props.width && Math.floor(+props.width / 1)) || 24}
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		fontSize="medium"
		ref={svgRef}
		{...props}
	>
		<path
			d="M20.4 20.4c1.988 0 2.4.537 2.4 1.2 0 .663-.412 1.2-2.4 1.2H6c-1.988 0-2.4-.537-2.4-1.2 0-.663.412-1.2 2.4-1.2h14.4zM10.097 7.903c.642.642.698 1.64.703 3.532v1.13c-.005 1.891-.061 2.89-.703 3.532-.703.703-1.834.703-4.097.703-2.263 0-3.394 0-4.097-.703-.642-.642-.698-1.64-.703-3.532v-1.13c.005-1.891.061-2.89.703-3.532.642-.642 1.64-.698 3.532-.703h1.13c1.891.005 2.89.061 3.532.703zM6.517 9.6H5.483c-.885.003-1.428.016-1.814.068C3.607 10.125 3.6 10.8 3.6 12v.268c.001 1.034.012 1.642.069 2.063.456.062 1.132.069 2.331.069 1.2 0 1.875-.007 2.331-.069.061-.456.069-1.132.069-2.331v-.268c-.001-1.034-.012-1.642-.069-2.063-.386-.052-.93-.065-1.814-.068zM20.4 10.8c1.988 0 2.4.537 2.4 1.2 0 .663-.412 1.2-2.4 1.2h-4.8c-1.988 0-2.4-.537-2.4-1.2 0-.663.412-1.2 2.4-1.2h4.8zm0-9.6c1.988 0 2.4.537 2.4 1.2 0 .663-.412 1.2-2.4 1.2H6c-1.988 0-2.4-.537-2.4-1.2 0-.663.412-1.2 2.4-1.2h14.4z"
			fill="currentColor"
			fillRule="evenodd"
		/>
	</svg>
))
ListIconSvg.displayName = 'ListIconSvg'

const ListIcon = forwardRef((props, ref) => <Icon component={ListIconSvg} ref={ref} {...props} />)
ListIcon.displayName = 'ListIcon'

ListIcon.defaultProps = {
	...Icon.defaultProps,
}
ListIcon.propTypes = {
	...Icon.propTypes,
}

export default ListIcon
export { ListIconSvg }
